import { FC } from 'react';
import classNames from 'classnames';

import { Counter } from '@/components';
import { NOT_DEFINED } from '@/constants';

import {
  getDefaultProductInfoComponents,
  ProductActionFavorite,
  ProductBadgeContainer,
  ProductImage,
  ProductInfoCarousel,
  ProductLinkWrapper,
  ProductName,
  ProductPrice,
  ProductVariants,
} from '../Product.components';
import { ProductVariationProps } from '../Product';
import { useProductContext } from '../context';

import style from '../product.module.scss';
import styleVariation from './ProductCardWithBtnHover.module.scss';

const ProductCardWithBtnHover: FC<ProductVariationProps> = ({
  className,
  analyticsListName,
  isLargeCard,
}) => {
  const { product, isSpecial, variants, weightVariant, compoundList } =
    useProductContext();

  const availableInfo = getDefaultProductInfoComponents(product, compoundList);

  return (
    <ProductLinkWrapper
      analyticsListName={analyticsListName}
      className={classNames(style.product, styleVariation.product, className)}
      product={product}
    >
      <div className={styleVariation.product__image_container}>
        <ProductImage
          className={styleVariation.product__image}
          product={product}
        />
        <Counter
          actionTheme="primary"
          className={classNames(styleVariation.actions__counter_hover, {
            [styleVariation.actions__counter_hover_largue_card]: isLargeCard,
          })}
          onCard
          product={product}
          selectedWeightVariant={weightVariant}
          showIcon
        />
      </div>
      <div className={style.product__body}>
        <ProductName name={product?.name || NOT_DEFINED} />
        <ProductBadgeContainer
          className={styleVariation.product__badges_container}
          product={product}
          weightVariant={weightVariant}
        />
        <ProductInfoCarousel
          className={styleVariation.variation__info_carousel}
        >
          {availableInfo}
        </ProductInfoCarousel>
        <ProductPrice
          className={styleVariation.product__price_container}
          elementVariants={<ProductVariants />}
          isOverflow={variants?.length === 1}
          isSpecial={isSpecial}
          type="expanded"
          weightVariant={weightVariant}
        />
        <div className={styleVariation.actions__body}>
          <ProductActionFavorite
            className={classNames(
              style.favorite_action,
              styleVariation.favorite__button,
            )}
            product={product}
          />
        </div>
        <div className={styleVariation.product__actions_footer}>
          <Counter
            actionTheme="primary"
            className={styleVariation.actions__counter}
            onCard
            product={product}
            selectedWeightVariant={weightVariant}
            showIcon
          />
        </div>
      </div>
    </ProductLinkWrapper>
  );
};

export { ProductCardWithBtnHover };
